export const singleBrandUrlRegex = /\/([\w-]+)\/brand/
